// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"687":"7f3eb7d5","874":"2242f458"}[chunkId] + ".chunk.js";
};